var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12048_19228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89258 9.728V22.272C2.89258 23.0784 3.31498 23.808 4.01898 24.2176L14.8862 30.4896C15.5774 30.8864 16.435 30.8864 17.1262 30.4896L27.9934 24.2176C28.6846 23.8208 29.1198 23.0784 29.1198 22.272V9.728C29.1198 8.9216 28.6974 8.192 27.9934 7.7824L17.1262 1.5104C16.435 1.1136 15.5774 1.1136 14.8862 1.5104L4.01898 7.7824C3.32778 8.1792 2.90538 8.9216 2.90538 9.728H2.89258Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3676 18.432L16.8188 22.6816C16.7804 22.7968 16.7804 22.9248 16.8188 23.0528L19.4812 30.3616L22.566 28.5824L18.8668 18.432C18.7772 18.2016 18.4572 18.2016 18.3676 18.432Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4782 11.2896C21.3886 11.0592 21.0686 11.0592 20.979 11.2896L19.4302 15.5392C19.3918 15.6544 19.3918 15.7824 19.4302 15.9104L23.795 27.8784L26.8798 26.0992L21.4782 11.3024V11.2896Z",
    fill: "#12AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 1.984C16.0766 1.984 16.1534 2.0096 16.2174 2.048L27.9678 8.832C28.1086 8.9088 28.1854 9.0624 28.1854 9.216V22.784C28.1854 22.9376 28.0958 23.0912 27.9678 23.168L16.2174 29.952C16.1534 29.9904 16.0766 30.016 15.9998 30.016C15.923 30.016 15.8462 29.9904 15.7822 29.952L4.03178 23.168C3.89098 23.0912 3.81418 22.9376 3.81418 22.784V9.2032C3.81418 9.0496 3.90378 8.896 4.03178 8.8192L15.7822 2.0352C15.8462 1.9968 15.923 1.9712 15.9998 1.9712V1.984ZM15.9998 0C15.5774 0 15.1678 0.1024 14.7838 0.32L3.03338 7.104C2.27818 7.5392 1.81738 8.3328 1.81738 9.2032V22.7712C1.81738 23.6416 2.27818 24.4352 3.03338 24.8704L14.7838 31.6544C15.155 31.872 15.5774 31.9744 15.9998 31.9744C16.4222 31.9744 16.8318 31.872 17.2158 31.6544L28.9662 24.8704C29.7214 24.4352 30.1822 23.6416 30.1822 22.7712V9.2032C30.1822 8.3328 29.7214 7.5392 28.9662 7.104L17.203 0.32C16.8318 0.1024 16.4094 0 15.987 0H15.9998Z",
    fill: "#9DCCED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21777 27.8912L9.30577 24.9216L11.4818 26.7264L9.44657 28.5952L8.21777 27.8912Z",
    fill: "#213147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0016 8.2432H12.0192C11.8016 8.2432 11.5968 8.384 11.52 8.5888L5.13281 26.0992L8.21761 27.8784L15.2576 8.5888C15.3216 8.4096 15.1936 8.2304 15.0144 8.2304L15.0016 8.2432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2239 8.2432H17.2415C17.0239 8.2432 16.8191 8.384 16.7423 8.5888L9.44629 28.5824L12.5311 30.3616L20.4671 8.5888C20.5311 8.4096 20.4031 8.2304 20.2239 8.2304V8.2432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12048_19228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.27b1b67f4db6d47de5a16706609b355c.svg";
export { ForwardRef as ReactComponent };